import { useHistory } from "react-router";
import { BreadCrumb, Header } from "@funcional/react-ui";
import { useCreateOAuth2Client } from "@sso/oauth2-clients/hooks";
import OAuth2ClientForm from "@sso/oauth2-clients/components/OAuth2ClientForm";
import { useState } from "react";
import { IGraphQLError } from "@common/contracts";

export default function CreateOAuth2ClientPage() {
  const [graphQLErrors, setGraphQLErrors] = useState<IGraphQLError[]>([]);
  const createOAuth2Client = useCreateOAuth2Client();

  const history = useHistory();

  const onSubmit = async (input: any) => {
    try {
      const record = await createOAuth2Client.mutateAsync(input);
      if (record?.id) {
        return history.push(`/sso/oauth2-clients/${record.id}`);
      }
    } catch (error: any) {
      console.error(error);
      if (error?.response?.errors) {
        return setGraphQLErrors(error.response.errors);
      }
      setGraphQLErrors([
        {
          message:
            "Não foi possível salvar o registro, tente novamente mais tarde.",
        },
      ]);
    }
  };

  return (
    <>
      <Header title="Novo Cliente de OAuth2" backTo="/sso/oauth2-clients">
        <BreadCrumb
          marginBottom={0}
          items={[
            { path: "/sso/oauth2-clients", label: "Clientes de OAuth2" },
            { label: "Novo" },
          ]}
        />
      </Header>

      <OAuth2ClientForm
        isLoading={createOAuth2Client.isLoading || createOAuth2Client.isSuccess}
        graphQLErrors={graphQLErrors}
        onSubmit={onSubmit}
      />
    </>
  );
}
